<template>
  <div>
    {{ getDate(orderData) | moment('YYYY-MM-DD hh:mm A') }}
    <div class="hover-content">
      <div class="popover-arrow">&nbsp;</div>
      <div class="d-flex my-2">
        <div style="width: 40%">Order Date</div>
        <div class="text-right">{{ getOrderDate(orderData) | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.pending_answer_at"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.pending_answer_at"
        class="d-flex my-2"
      >
        <div style="width: 40%">Pending Answer Date</div>
        <div class="text-right">{{ orderData.pending_answer_at | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.process_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.process_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Process Date</div>
        <div class="text-right">{{ orderData.process_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.cancel_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.cancel_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Cancel Date</div>
        <div class="text-right">{{ orderData.cancel_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.confirm_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.confirm_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Approve Date</div>
        <div class="text-right">{{ orderData.confirm_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.refund_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.refund_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Refund Date</div>
        <div class="text-right">{{ orderData.refund_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.purchase_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.purchase_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Purchase Date</div>
        <div class="text-right">{{ orderData.purchase_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.warehouse_deliver_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.warehouse_deliver_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Warehouse Date</div>
        <div class="text-right">{{ orderData.warehouse_deliver_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.int_shipment_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.int_shipment_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Shipment Date</div>
        <div class="text-right">{{ orderData.int_shipment_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.pending_to_branch_at"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.pending_to_branch_at"
        class="d-flex my-2"
      >
        <div style="width: 40%">
          <div>Pending To Branch</div>
        </div>
        <div class="text-right">{{ orderData.pending_to_branch_at | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.branch_delivery_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.branch_delivery_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Delivered to Erbil</div>
        <div class="text-right">{{ orderData.branch_delivery_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.deliver_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.deliver_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">Delivered Date</div>
        <div class="text-right">{{ orderData.deliver_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['orderData'],

  methods: {
    getOrderDate(order) {
      return order.order_date ? order.order_date : order.created_at
    },

    getDate(order) {
      if (order.status_id_fk === 1) {
        return order.order_date ? order.order_date : order.created_at
      }

      if (order.status_id_fk === 2) return order.process_date

      if (order.status_id_fk === 3 || order.is_canceled === '1') return order.cancel_date

      if (order.status_id_fk === 4) return order.confirm_date

      if (order.status_id_fk === 5) return order.refund_date

      if (order.status_id_fk === 6) return order.purchase_date

      if (order.status_id_fk === 7) return order.warehouse_deliver_date

      if (order.status_id_fk === 8) return order.int_shipment_date

      if (order.status_id_fk === 9) return order.branch_delivery_date

      if (order.status_id_fk === 10) return order.deliver_date

      if (order.status_id_fk === 12) return order.order_date

      if (order.status_id_fk === 13) return order.pending_to_branch_at

      if (order.status_id_fk === 14) return order.pending_answer_at
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/viewOrderDates.vue